module.exports = __webpack_public_path__ + "images/FUSA_icons/041-online-shop-8.fa4301ed01f6f0bb0fae49e5d4ce88bb.svg";